import { DEFAULT_LAYOUT_SETTINGS, sanitizeLayoutSettings } from "./layout-settings.js";

const LAYOUT_KEYS = Object.keys(DEFAULT_LAYOUT_SETTINGS);
const VIEW_KEYS = ["paths", "view", "person", "edge", "domains", "relation", "paused", "camera", ...LAYOUT_KEYS];

export function parseView(search, { domains = [], relations = [], fallbackSettings = DEFAULT_LAYOUT_SETTINGS } = {}) {
  const params = new URLSearchParams(search);
  const shared = params.get("view") === "1";
  const settings = { ...(shared ? DEFAULT_LAYOUT_SETTINGS : fallbackSettings) };
  for (const key of LAYOUT_KEYS) {
    const raw = params.get(key);
    if (raw?.trim() && Number.isFinite(Number(raw))) settings[key] = Number(raw);
  }
  const rawCamera = params.get("camera")?.split(",");
  const values = rawCamera?.map(Number);
  const camera = rawCamera?.length === 4 && rawCamera.every(v => v.trim() !== "") && values.every(Number.isFinite)
    && Math.abs(values[0]) <= 10000 && Math.abs(values[1]) <= 10000 && values[2] >= .02 && values[2] <= 30
    && Math.abs(values[3]) <= Math.PI * 2
    ? Object.fromEntries(["x", "y", "ratio", "angle"].map((key, i) => [key, values[i]])) : null;
  return {
    pathIds: [...new Set((params.get("paths") || "").split(",").filter(id => /^Q[1-9][0-9]*$/.test(id)))].slice(0, 3),
    layoutSettings: sanitizeLayoutSettings(settings), camera,
    paused: params.get("paused") === "1",
    domains: [...new Set((params.get("domains") || "").split(",").filter(v => domains.includes(v)))],
    relationType: relations.includes(params.get("relation")) ? params.get("relation") : "ALL",
    selectedNode: params.get("person")?.slice(0, 200) || null,
    selectedEdge: params.has("person") ? null : params.get("edge")?.slice(0, 200) || null,
  };
}

// Explicit settings make shared views independent of the recipient's local preferences.
// Positions are not serialized: this is a live network, not a frozen snapshot.
export function serializeView(baseUrl, state) {
  const url = new URL(baseUrl);
  for (const key of VIEW_KEYS) url.searchParams.delete(key);
  url.searchParams.set("view", "1");
  if (state.pathIds?.length) url.searchParams.set("paths", state.pathIds.join(","));
  if (state.selectedNode) url.searchParams.set("person", state.selectedNode);
  else if (state.selectedEdge) url.searchParams.set("edge", state.selectedEdge);
  if (state.domains.size || state.domains.length) url.searchParams.set("domains", [...state.domains].join(","));
  if (state.relationType !== "ALL") url.searchParams.set("relation", state.relationType);
  url.searchParams.set("paused", state.paused ? "1" : "0");
  for (const [key, value] of Object.entries(sanitizeLayoutSettings(state.layoutSettings))) url.searchParams.set(key, String(value));
  if (state.camera) url.searchParams.set("camera", ["x", "y", "ratio", "angle"].map(key => Number(state.camera[key].toFixed(6))).join(","));
  return url.href;
}

export function socialLinks(url) {
  const text = "Entourages — un réseau de relations documentées";
  return [
    { label: "Bluesky", url: `https://bsky.app/intent/compose?${new URLSearchParams({ text: url })}` },
    { label: "X", url: `https://twitter.com/intent/tweet?${new URLSearchParams({ text, url })}` },
    { label: "WhatsApp", url: `https://wa.me/?${new URLSearchParams({ text: `${text}\n${url}` })}` },
  ];
}
